import { createAsyncThunk } from '@reduxjs/toolkit';

import { ITransactionLog } from '.';
import {
  APIDataProvider,
  ApiPaths,
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api';

export type TGetTransactionLogs = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  startDate?: string;
  endDate?: string;
};

const apiDataProvider = new APIDataProvider();

const getTransactionLogsModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  startDate,
  endDate,
}: TGetTransactionLogs) => {
  let path = `${ApiPaths.transactionLogs}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (startDate) {
    path += `&startDate=${startDate}`;
  }

  if (endDate) {
    path += `&endDate=${endDate}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<ITransactionLog>>
  >(path);

  return response.data;
};

export const getTransactionLogs = createAsyncThunk(
  '/transaction-logs/list',
  getTransactionLogsModule
);
